(() => {
  function syncFaq(root = document) {
    const source = root.querySelector('[data-shared-faq-template]') || document.querySelector('[data-shared-faq-template]');
    const target = document.querySelector('[data-product-faq-tab]');
    if (!source || !target) return;
    target.replaceChildren(source.content.cloneNode(true));
  }

  function refreshJudgeMe() {
    if (window.jdgm?.refreshWidgets) window.jdgm.refreshWidgets();
  }

  function mountReviews() {
    const source = document.querySelector('[data-reviews-faq]');
    const target = document.querySelector('[data-product-reviews-tab]');
    const reviews = source?.querySelector('[data-reviews-faq-reviews]');
    if (!target || !reviews?.querySelector('.jdgm-review-widget')) return;

    // Move the installed app block rather than creating a second widget. This
    // preserves Judge.me's product data, form handlers and theme editor settings.
    target.replaceChildren(reviews);
    source.dataset.reviewsLocation = 'tab';
    refreshJudgeMe();
  }

  function showReviews() {
    const panel = document.querySelector('[data-product-reviews-tab]');
    if (!panel?.querySelector('.jdgm-review-widget')) return false;
    panel.closest('[data-product-tabs]')?.dispatchEvent(new CustomEvent('product-reviews:show'));
    panel.scrollIntoView({ block: 'start' });
    return true;
  }

  function setup(root) {
    syncFaq(root);
    mountReviews();
  }

  const reviewAnchors = ['#ProductReviews', '#judgeme_product_reviews'];
  setup(document);
  if (reviewAnchors.includes(window.location.hash)) showReviews();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const source = document.querySelector('[data-reviews-faq]');
    const panel = document.querySelector('[data-product-reviews-tab]');
    const reviews = panel?.querySelector('[data-reviews-faq-reviews]');
    if (!source || !reviews) return;

    // Return the app block before either section is replaced in the editor.
    if (event.target.contains(panel) || event.target.contains(source)) {
      source.querySelector('[data-product-reviews-slot]')?.append(reviews);
      delete source.dataset.reviewsLocation;
    }
  });
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.origin !== window.location.origin || link.pathname !== window.location.pathname) return;
    if (reviewAnchors.includes(link.hash) && showReviews()) event.preventDefault();
  });
  window.addEventListener('hashchange', () => {
    if (reviewAnchors.includes(window.location.hash)) showReviews();
  });
})();
